import React from 'react'
import { Route } from 'react-router'
import { store } from '../index'
import { Permission } from '../configs/constants/roles.const'

const PrivateRoute: React.FC<any> = ({ component: Component, roleAllow, permissions, ...rest }) => {
  const userInfo = store.getState().loginReducer.userInfo
  const hasRole = !!userInfo && !!roleAllow && roleAllow.includes(userInfo.role)
  const isActivated = userInfo?.status === 'Activated'
  let hasPermission = true

  if (permissions?.length) {
    permissions.forEach((permission: string) => {
      switch (permission) {
        case Permission.EAI_LICENSES:
          hasPermission = userInfo.eaiLicensesPermission === 1
          break
        case Permission.PRODUCT_PERMISSION:
          hasPermission = userInfo.productManagementPermission === 1
          break
      }
    })
  }
  const isAuthen = hasRole && isActivated && hasPermission

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthen) {
          return <Component {...props} />
        } else if (!!userInfo) {
          window.location.href = '/login-error'
        } else {
          window.location.href = 'loginPage.html'
        }
      }}
    />
  )
}

export default PrivateRoute
